import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = { class: "table-content-head__name" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "agila-icon-info",
  tabindex: "0"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["onClick", "onKeyup"]
const _hoisted_7 = { class: "table-content-column__name" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "agila-icon-info",
  tabindex: "0"
}
const _hoisted_10 = ["innerHTML"]

import { ref } from "vue";
import { Feature } from "../../classes/feature";
import { ProductGroup } from "../../classes/productGroup";

interface Props {
  productGroup: ProductGroup;
  feature: Feature;
  defaultProduct: number | null;
  highlightDefaultProduct: boolean;
  liability: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableContentRowComponent',
  props: {
    productGroup: { default: null },
    feature: { default: null },
    defaultProduct: { default: null },
    highlightDefaultProduct: { type: Boolean, default: false },
    liability: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const extendedRows = ref<{ [key: string]: boolean }>({});

if (props.productGroup?.products?.length < 3) {
  extendedRows.value = { "43": true };
}

function extendRow(key: number): void {
  extendedRows.value[key] = !extendedRows.value[key];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-content-row",
    "data-cy": 'product-row-' + props.feature.id
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["table-content-head", { 'cursor-pointer': props.feature.description }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        props.feature.description ? extendRow(props.feature.id) : undefined
      )),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (
        props.feature.description ? extendRow(props.feature.id) : undefined
      ), ["enter"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          innerHTML: props.feature.value
        }, null, 8, _hoisted_3),
        (props.feature.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      (props.feature.subValue || extendedRows.value[props.feature.id])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-small",
            innerHTML: props.feature.subValue || props.feature.description
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ], 34),
    _createElementVNode("div", {
      class: _normalizeClass(["table-content-columns", {
        'hps-combi': _ctx.productGroup?.products?.length < 3,
        'single-product': _ctx.productGroup?.products?.length === 1,
        liability: props.liability,
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGroup.products, (product, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["table-content-column", {
          'cursor-pointer': product.getFeatureValue(props.feature.id)
            ?.description,
          'non-highlight-column':
            props.highlightDefaultProduct &&
            props.defaultProduct !== 0 &&
            props.defaultProduct !== index + 1,
        }]),
          key: product.id,
          onClick: ($event: any) => (
          product.getFeatureValue(props.feature.id)?.description
            ? extendRow(props.feature.id)
            : undefined
        ),
          onKeyup: _withKeys(($event: any) => (
          product.getFeatureValue(props.feature.id)?.description
            ? extendRow(props.feature.id)
            : undefined
        ), ["enter"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            (
              typeof product.getFeatureValue(props.feature.id)?.value ===
              'string'
            )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: product.getFeatureValue(props.feature.id)?.value
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass({
              'agila-icon-check':
                product.getFeatureValue(props.feature.id)?.value === true,
              'agila-icon-skip':
                product.getFeatureValue(props.feature.id)?.value === false,
            })
                }, null, 2)),
            (product.getFeatureValue(props.feature.id)?.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          (
            product.getFeatureValue(props.feature.id)?.subValue ||
            extendedRows.value[props.feature.id]
          )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-small",
                innerHTML: 
            product.getFeatureValue(props.feature.id)?.subValue ||
            product.getFeatureValue(props.feature.id)?.description
          
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ], 42, _hoisted_6))
      }), 128))
    ], 2)
  ], 8, _hoisted_1))
}
}

})